"use client";

export default function Home() {
  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <div className="flex flex-col items-stretch gap-2">SESI SALTING</div>
    </div>
  );
}
